import { render, staticRenderFns } from "./DotBouncer.vue?vue&type=template&id=25b55e64&"
import script from "./DotBouncer.vue?vue&type=script&lang=js&"
export * from "./DotBouncer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports